import _ from 'underscore';
import { BaseValidator } from './base-validator';

const validateObject = val => _.isObject(val);
const validateNumber = (val, propertySchema) => {
  const num = Number(val);

  if (_.isNaN(num)) {
    return false;
  }

  const { minimum, maximum } = propertySchema;

  return (_.isUndefined(minimum) || num >= minimum)
    && (_.isUndefined(minimum) || num <= maximum);
};
const validateString = val => _.isString(val) && val.length > 0;

const TypeValidateConfig = {
  object: validateObject,
  number: validateNumber,
  string: validateString,
};

export class TypeValidator extends BaseValidator {
  constructor(propertySchema) {
    super(propertySchema);

    const { type, minimum, maximum } = propertySchema;

    this.type = type;
    this.minimum = minimum;
    this.maximum = maximum;
  }

  get requiredField() {
    return 'type';
  }

  internalValidate(propertyValue) {
    const validateFunc = TypeValidateConfig[this.type];

    if (!validateFunc) {
      throw new Error(`There are no configured validateFunc for this type: ${this.type}`);
    }

    return validateFunc(propertyValue, this.propertySchema);
  }
}
